// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"11beb3ca","389":"7d734e24","453":"a16784dc","455":"703c7542","857":"aa8ed4d7","977":"a6c57775"}[chunkId] + ".chunk.js";
};